import { mapMutations } from 'vuex';
import EditMixin from '@/components/core/dtwin/editMixin';
import detailsViewMixin from '@/components/core/virtualDevice/detailsViewMixin';
import GeoDataMixin from '@/components/core/dtwin/geoDataMixin';
import mixinActionBoxStyles from '@/components/core/mixinActionBoxStyles';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewVirtualDevicesDetails',
  mixins: [EditMixin, GeoDataMixin, mixinActionBoxStyles, detailsViewMixin],
  data: function () {
    return {
      tabItem: this.$route.query.stateId ? 'tab-states' : this.$route.query.ruleId ? 'tab-rules' : 'tab-deviceinfo',
      shouldOpenStateDetail: !!this.$route.query.stateId
    };
  },
  computed: {
    headerBG() {
      if (get(this.twinObject, 'data.twinImageId')) {
        return `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}/upload/${this.twinObject.data.twinImageId}`;
      }
      return null;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {},
  created() {
    this.baseLink = 'virtual-devices';
    this.apiMethodGet = 'virtualDeviceGet';
    this.apiGeoHistoryFetchMethod = 'virtualDeviceFetchGeoHistory';
    this.apiMethodUpdate = 'virtualDeviceUpdate';
    this.apiMethodToggleDisabled = 'virtualDeviceUpdateDisabled';
    this.permissionSubject = 'VirtualDevice';
    this.twinObject = {
      data: {},
      properties: {
        bridge: {
          deviceData: {}
        }
      },
      'dynamical-data-routing-target': [{}]
    };
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    onChangeDeviceDriver(newDriverId) {
      const clonedTwinObject = cloneDeep(this.twinObject);
      delete clonedTwinObject.data.virtualDevice.deviceTypeId;
      clonedTwinObject.data.virtualDevice.deviceDriverId = newDriverId;
      this.twinObject = clonedTwinObject;
    },
    onChangeDeviceType(newDeviceTypeId) {
      const clonedTwinObject = cloneDeep(this.twinObject);
      delete clonedTwinObject.data.virtualDevice.deviceDriverId;
      clonedTwinObject.data.virtualDevice.deviceTypeId = newDeviceTypeId;
      this.twinObject = clonedTwinObject;
    },
    onUnlinkDeviceTeTemplate() {
      this.deviceTemplate = null;
    },
    onChangedBridgeParams(deviceData) {
      const clonedDeviceData = cloneDeep(deviceData);
      this.twinObject.properties.bridge.deviceData = clonedDeviceData;
    },
    handleUpdate(value) {
      this.twinObject['dynamical-data-routing-target'] = value;
    }
  }
};